import Launch16 from '@carbon/icons-react/es/launch/16';
import { Menu } from 'antd';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import React, { FC } from 'react';
import styled from 'styled-components';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';

const MenuItem = styled(Menu.Item)`
  a {
    display: flex;
    align-items: center;
    gap: var(--spacing-04);
    color: var(--primary-color);
  }
  span {
    flex: 1;
  }
`;

interface Props extends MenuItemProps {
  linkTo: string;
}

const BaseLink: FC<Props> = (params) => {
  const { icon = <Launch16 />, children, linkTo } = params;

  return (
    <MenuItem {...params}>
      <a href={linkTo} target="_blank" rel="noreferrer">
        {icon} {children}
      </a>
    </MenuItem>
  );
};

export const Link = withHideIfNotAllowed(BaseLink);
